module.exports = __webpack_public_path__ + "img/07-10-02.584914c7.png";